import React, { useEffect, useState } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';
import { breadCrumbsStore } from './BreadCrumbsListner';


type BreadcrumbItem = { [label: string]: string };

const WSCustomBreadcrumbs: React.FC = () => {
    const [labelList, setLabelList] = useState<BreadcrumbItem[]>(breadCrumbsStore.getLabel());
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = breadCrumbsStore.subscribe(setLabelList);
        return () => unsubscribe();
    }, []);

    const breadcrumbs = labelList.map((item, index) => {
        const label = Object.keys(item)[0];
        const href = item[label];
        const isLast = index === labelList.length - 1;

        if (isLast) {
            return (
                <Typography key={label} fontSize={'0.75rem'} fontWeight={'bold'} color="text.primary">
                    {label}
                </Typography>
            );
        }

        return (
            <Link
                key={label}
                underline="hover"
                color="inherit"
                component="button"
                sx={{ fontSize: '0.75rem' }}
                onClick={() => navigate(href)} // ✅ This line is key
            >
                {label}
            </Link>
        );
    });

    return (
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            {breadcrumbs}
        </Breadcrumbs>
    );
};

export default WSCustomBreadcrumbs;
